import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useThemeColors } from '@/hooks/residents/useThemeColors';

interface PaymentSectionDividerProps {
  style?: any;
}

export const PaymentSectionDivider: React.FC<PaymentSectionDividerProps> = ({ style }) => {
  const { colors } = useThemeColors();
  return <View style={[styles.sectionDivider, { backgroundColor: colors.separator }, style]} />;
};

const styles = StyleSheet.create({
  sectionDivider: {
    height: 1,
  },
});
